import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";
import {ENTITY_NUMBER_GEN_GROUP_LIST} from "../constants";
import {PAGE} from "../../routes";
import {ZzFlatButtonRoute} from "../../core/components/buttons/buttons";

@observer
export default class EntityNumberGenGroupList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.invoicing;
  static title = loc.i18n`Entity number gen`;
  static icon = 'line-chart';
  static rootPage = true;
  static protectedPage = true;

  static fetchData(routerParams) {
    console.log("EntityNumberGenGroupList#fetchData(%s)", ENTITY_NUMBER_GEN_GROUP_LIST);

    return gridService.fetchGrids(ENTITY_NUMBER_GEN_GROUP_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(ENTITY_NUMBER_GEN_GROUP_LIST);
      });
  }

  render() {
    let {params, query} = this.props;

    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(ENTITY_NUMBER_GEN_GROUP_LIST)}
                         entities={mdEntityService.entityMap}
                         gridId={params.gridId} query={query}>
        <ZzFlatButtonRoute onGridToolbar routeName="entityNumberGenGroupDetail" params={{id: 'new'}}
                           label={loc.i18n`number.gen.group.new`} permission={PERMISSION.New} securable={PAGE.entityNumberGenGroupDetail}/>

      </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/invoice/page/entityNumberGenGroupList.tsx